import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useCustomTheme } from "../context/ThemeContext";

export default function StickyNote({ title, content }) {
  const { themeSettings } = useCustomTheme();

  return (
    <Card
      elevation={0}
      sx={{
        backgroundColor: themeSettings?.schedule_card_bg || "#D4BBDD",
        borderRadius: "24px",
      }}
    >
      <CardContent>
        <Stack spacing={1.5} alignItems="center">
          <Typography variant="h6">
            {title}
          </Typography>

          {/* === MODIFICHE QUI === */}
          <Typography
            variant="body1" // 1. Ingrandito da "body2" a "body1"
            sx={{
              whiteSpace: 'pre-line',
              textAlign: 'center',
              lineHeight: 1.7,   // 2. Aggiunto spazio tra le righe
              fontWeight: 500,   // 3. Aggiunto un leggero grassetto
            }}
          >
            {content}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}